import { c as _c } from "react/compiler-runtime";
import React from 'react';
import IconMobileGrid1x from 'components/icons/iconMobileGrid1x';
import IconMobileGrid2x from 'components/icons/iconMobileGrid2x';
import MobileOnly from 'components/consumer/MobileOnly';
import useMobileColumnCount from '../../state/mobileColumnCount/useMobileColumnCount';
import useToggleMobileColumnCount from '../../state/mobileColumnCount/useToggleMobileColumnCount';
const MobileGridColumnToggle = () => {
  const $ = _c(5);
  const mobileColumnCount = useMobileColumnCount();
  const toggleMobileColumnCount = useToggleMobileColumnCount();
  let t0;
  if ($[0] !== mobileColumnCount) {
    t0 = mobileColumnCount === "1" ? <IconMobileGrid1x /> : <IconMobileGrid2x />;
    $[0] = mobileColumnCount;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0 || $[3] !== toggleMobileColumnCount) {
    t1 = <MobileOnly><button type="button" className="flex md:hidden items-center justify-center min-w-[29px]" onClick={toggleMobileColumnCount}>{t0}</button></MobileOnly>;
    $[2] = t0;
    $[3] = toggleMobileColumnCount;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export default MobileGridColumnToggle;